<template>
	<div class="header">
		<div class="header_main_box">
			<ul class="header_top_box">
				<li><a href="http://www.drcnet.com.cn/www/int/">国研网</a></li>
				<li>
					<a
						v-show="!users.token"
						:href="
							'http://d.drcnet.com.cn/eDRCNet.Common.Web/login/login.aspx?gourl=http://' +
								urlHost +
								'/index.html#/Index'
						"
						id="login-text"
						>登录</a
					>
					<span
						v-show="users.token"
						@click="unloginFn"
						style="cursor: pointer"
						>退出登录</span
					>
				</li>
				<li v-show="users.token">
					<span>您好，{{ users.userName }}</span>
				</li>
				<li>
					<a
						v-show="!users.token"
						href="http://misc.drcnet.com.cn/DRCNet.Users.Web/User/UserReg1.aspx"
						target="_blank"
						>注册</a
					>
				</li>
				<li>
					<a
						target="_blank"
						href="http://www.drcnet.com.cn/eDRCNet.Order.Web/Order/User/UserMain.aspx"
						>会员专区</a
					>
				</li>
				<li>
					<a target="_blank" href="https://www.drcnet.com.cn/help"
						>使用帮助</a
					>
				</li>
				<li>
					<router-link
						target="_blank"
						:to="{ path: '/introduce' }"
						style="border: 0"
						>产品介绍</router-link
					>
				</li>
				<li>
					<a
						target="_blank"
						href="http://company.drcnet.com.cn/about.html"
						>关于我们</a
					>
				</li>
			</ul>
			<!-- 
			<img
				class="header_top_title"
				src="../assets/header/text.png"
				alt=""
			/> -->
			<div class="header_top_input_box">
				<el-input
					placeholder="请输入关键词"
					v-model="input3"
					class="input-with-select"
				>
					<el-select
						class="header-select"
						v-model="select"
						slot="prepend"
						placeholder="请选择"
					>
						<el-option label="全文" value="0"></el-option>
						<el-option label="标题" value="1"></el-option>
						<!-- <el-option label="作者" value="2"></el-option> -->
						<el-option label="关键词" value="3"></el-option>
						<!-- <el-option label="来源" value="4"></el-option> -->
					</el-select>
					<el-button
						@click="searchbtn"
						class="header-search-btn"
						slot="append"
						>检索</el-button
					>
				</el-input>
				<a
					class="header-search-btn2"
					target="blank"
					href="http://s1.drcnet.com.cn/search/searchAC.aspx?fields=1^1^1&chnid=7074#"
					>检索中心</a
				>
				<a
					class="header-search-btn3"
					target="blank"
					href="https://search.drcnet.com.cn/aiSearch"
					>AI检索</a
				>
			</div>
		</div>
		<div class="header_main2_box" :class="isfixed ? 'fixed' : ''">
			<div class="header_main2_center_box">
				<a href="/index.html" class="header_index_url">首 页</a>
				<a
					v-if="item.remark == '首页'"
					href="javascript:void(0);"
					class="header_index_url"
					v-for="(item, index) in dataList"
					:id="
						'hover_item_' +
							(item.title_code ? item.title_code : index)
					"
					@mouseleave="hoverLeaveFn"
					@mouseenter="
						hoverHeaderfn(
							'hover_item_' +
								(item.title_code ? item.title_code : index)
						)
					"
					@click.stop="pageToUrl(item.url, item.title_name)"
					:key="index"
				>
					{{ item.title_name }}
					<!-- <img
						v-if="
							item.title_code == 'A617' ||
								item.title_code == 'A619'
						"
						src="../assets/homeContent/new.gif"
						alt=""
						style="vertical-align: 12%;"
					/> -->
					<el-card
						v-if="item.childrenList.length > 0"
						class="box-card header_top_alert_box"
					>
						<!-- <a class="text item" v-for="(smItem,j) in sitem.childrenList" :key="j" @click="pageToUrl('/column?id=' + smItem.id + '&name=' + sitem.title_name)" href="javascript:void(0);">{{smItem.title_name}}</a> -->
						<a
							class="text item"
							v-for="(smItem, j) in item.childrenList"
							:key="j"
							@click.stop="
								pageToUrlTwo(smItem.title_name, 0, smItem)
							"
							href="javascript:void(0);"
							>{{ smItem.title_name }}</a
						>
						<!-- <router-link :to="{path:sitem.title_name == '产品数据' ? '/lvcolumn?id=' + smItem.id + '&name=' + sitem.title_name : '/column?id=' + smItem.id + '&name=' + sitem.title_name + '&uid=' + smItem.uid}" v-for="(smItem,j) in sitem.childrenList" :key="j" class="text item" style="border: 0;">{{smItem.title_name}}</router-link> -->
					</el-card>
				</a>
			</div>
			<div class="hotKeyImg">
				<div class="hotKey">
					<span class="hotTitle">热门关键字：</span>
					<span
						class="hotName"
						v-for="(item, index) in hotList"
						:key="index"
					>
						<a
							href="javascript:void(0);"
							@click="pageToUrlHot(item)"
							target=""
						>
							{{ item.name }}
						</a>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import $ from 'jquery';

export default {
	props: ['scrollTop'],
	components: {},
	data() {
		return {
			input1: '',
			input2: '',
			input3: '',
			select: '0',
			isfixed: false, //吸顶条
			dataList: {}, //导航数据
			users: '',
			guid: '',
			urlHost: window.location.host,
			hotList: [],
		};
	},
	watch: {
		//吸顶条滚动传值
		scrollTop(val) {
			// //console.log(val);
			this.handleScroll(val);
		},
		guid(val) {
			if (val) {
				this.loginFn();
			}
		},
	},
	methods: {
		//判断是否有权限
		ifRightsFn() {
			return new Promise(function(resolve, reject) {
				api.weighterRights('2682').then((res) => {
					resolve(res.data);
				});
			});
		},
		loginFn() {
			let _this = this;
			let tmpGuid = this.guid;
			api.iflogin(tmpGuid).then((res2) => {
				function showData(val) {
					return val;
				}
				let res = eval(res2);

				if (res.UserToken) {
					_this.ifRightsFn().then((ress) => {
						let tmpObj = {
							loginId: res.Logined,
							token: res.UserToken,
							userName: res.UserName,
							rights: ress ? 1 : 0,
							userId: res.userId,
						};
						// //console.log(tmpObj, 'tmpObj');

						localStorage.setItem(
							'usersInfo',
							JSON.stringify(tmpObj)
						);

						sessionStorage.setItem('Authorization', res.UserToken);

						_this.users = tmpObj;

						_this.$emit('getLoginInfo', tmpObj);
					});
				} else {
					localStorage.removeItem('usersInfo');
					sessionStorage.removeItem('Authorization');

					_this.users = '';

					_this.$emit('getLoginInfo', '');
				}
			});
		},
		//退出登录
		unloginFn() {
			let _this = this;
			let tmpGuid = this.guid;
			api.unlogin(tmpGuid).then((res) => {
				console.log(res);
				if (!res.code) {
					localStorage.removeItem('usersInfo');

					sessionStorage.removeItem('Authorization');

					_this.users = '';

					_this.$emit('getLoginInfo', '');

					// window.location.reload();

					_this.$router.push({ path: '/index' });
					// window.location.reload();

					// window.history.go(0);
				}
				//2024-7-10修改 之前下面这个ajax的接口都没调用到 所以逻辑都没走
				// $.ajax({
				// 	url:
				// 		'https://d.drcnet.com.cn/login/login.ashx?flag=logoutp', //initp 查询目前用户登录状态，logoutp 退出登录
				// 	type: 'post',
				// 	dataType: 'jsonp', //指定服务器返回的数据类型
				// 	jsonpCallback: 'showDatas', //指定回调函数名称
				// 	xhrFields: { withCredentials: true },
				// 	crossDomain: true,
				// 	async: false,
				// 	success: function(data) {
				// 		console.log(data);
				// 		console.log(res);
				// if (!data.code) {
				// 	localStorage.removeItem('usersInfo');

				// 	sessionStorage.removeItem('Authorization');

				// 	_this.users = '';

				// 	_this.$emit('getLoginInfo', '');

				// 	window.reload();

				// 	_this.$router.push({ path: '/index' });
				// 	// window.location.reload();

				// 	// window.history.go(0);
				// }
				// 	},
				// });
			});
		},
		figgerPrint() {
			let _this = this;

			let myOptions = getDRCNetFingerConfig();
			// //console.log(myOptions,'myOptions')
			if (window.requestIdleCallback) {
				Fingerprint2.get(myOptions, function(components) {
					// //console.log(components,'components');
					var option = components
						.filter(function(pair) {
							if (
								pair.key == 'userAgent' ||
								pair.key == 'availableScreenResolution'
							) {
								return false;
							}
							return true;
						})
						.map(function(pair) {
							return pair.value;
						});
					var murmur = Fingerprint2.x64hash128(option.join(), 31);
					// document.querySelector("#fp").textContent = murmur;
					_this.guid = murmur;
					// //console.log(murmur, "murmur1");
				});
			} else {
				setTimeout(() => {
					Fingerprint2.get(myOptions, function(components) {
						// //console.log(components,'components');
						var option = components
							.filter(function(pair) {
								if (
									pair.key == 'userAgent' ||
									pair.key == 'availableScreenResolution'
								) {
									return false;
								}
								return true;
							})
							.map(function(pair) {
								return pair.value;
							});
						var murmur = Fingerprint2.x64hash128(option.join(), 31);
						// document.querySelector("#fp").textContent = murmur;
						_this.guid = murmur;
						// //console.log(murmur, 'murmur2');
					});
				}, 500);
			}
		},
		//点击搜索按钮
		searchbtn() {
			let _input = this.input3; //搜索关键字
			let _select = this.select; //选项

			if (_input.length === 0) {
				this.$message({
					message: '请输入查询信息',
					type: 'warning',
				});
				return;
			}

			let _url =
				'http://s1.drcnet.com.cn/search/searchAC.aspx?fields=' +
				_select +
				'^1^1^' +
				escape(_input) +
				'&cp=1&ps=20&chnid=7074';
			window.open(_url);
		},
		//吸顶条
		handleScroll(val) {
			//父组件传值就用传过来的，不传就用本页面的
			let _scrollTop = val ? val : document.documentElement.scrollTop;

			if (
				_scrollTop >=
				document.getElementsByClassName('header_main_box')[0]
					.offsetHeight
			) {
				// //console.log('fixed')
				this.isfixed = true;
			} else {
				// //console.log('unfixed')
				this.isfixed = false;
			}
		},
		// 获取导航数据
		fetchData() {
			api.getheaderdata().then((res) => {
				this.dataList = res.data;
				for (let index = 0; index < res.data.length; index++) {
					const element = res.data[index];
					this.dataList[index].childrenList = [];
					if (element.is_two == '1') {
						for (let j = 0; j < res.data.length; j++) {
							const element2 = res.data[j];
							if (element.id == element2.parent_id) {
								this.dataList[index].childrenList.push(
									element2
								);
							}
						}
					}
				}
			});
			api.getHotWordsList().then((res) => {
				// //console.log(res.data, 'res.data');
				this.hotList = res.data;
			});
		},
		//鼠标hover显示下级弹窗
		hoverHeaderfn(id) {
			$('.header_top_alert_box').removeClass('active');
			$('#' + id + ' .header_top_alert_box').addClass('active');
			// //console.log(this,'this')
		},
		//鼠标离开
		hoverLeaveFn() {
			$('.header_top_alert_box').removeClass('active');
		},
		pageToUrlHot(item) {
			// console.log(item);

			if (item.url) {
				this.$router
					.replace({
						path: url,
					})
					.catch((err) => {
						if (err.name !== 'NavigationDuplicated') {
							console.error(err);
						}
					});
				window.location.reload();
			} else {
				if (item.associated) {
					// console.log(item.associated.split(','));
					let strArr = item.associated.split(',');
					let routerStr = '';
					if (strArr.length > 0) {
						for (let index = 0; index < strArr.length; index++) {
							const element = strArr[index];
							routerStr += `${
								index !== 0 ? '|' : ''
							}1^1^2^${escape(element)}`;
						}
						window.open(
							`http://s1.drcnet.com.cn/search/searchAC.aspx?fields=${routerStr}&cp=1&ps=20&chnid=7074`,
							'_blank'
						);
						// console.log(routerStr);
					} else {
						window.open(
							`http://s1.drcnet.com.cn/search/searchAC.aspx?fields=3^1^1^${escape(
								item.name
							)}&cp=1&ps=20&chnid=7074`,
							'_blank'
						);
					}
				}
				// let str = `http://s1.drcnet.com.cn/search/SearchAC.aspx?chnId=7074&&fields=1^1^2^%u78B3%u8FBE%u5CF0|1^1^2^%u78B3%u4E2D%u548C|1^1^2^%u8FBE%u5CF0&rootlm=c7074|c7074&ps=20&cp=1`;
			}
		},
		//点击链接跳转页面
		pageToUrl(url, name) {
			if (url && name != '统计数据') {
				this.$router
					.replace({
						path: url,
					})
					.catch((err) => {
						if (err.name !== 'NavigationDuplicated') {
							console.error(err);
						}
					});
				window.location.reload();
			} else {
				return;
			}
		},
		//点击链接跳转页面
		pageToUrlTwo(_name, num = 0, item) {
			// title_name
			// sitem.title_name == '能源数据' ? '/encolumn?id='+sitem.id+'&name=' + sitem.title_name + '&uid=1-0' : (sitem.title_name == '交易数据' ? '/trancolumn?id='+sitem.id+'&name=' + sitem.title_name : (sitem.title_name == '信息定制' ? '/infor' : (sitem.title_name == '课题咨询' ? '/topic' : '/discolumn?id='+sitem.id+'&name=' + sitem.title_name)))
			let _this = this;
			let tmpGuid = this.guid;
			// //console.log(_name,'name');
			switch (_name) {
				case '能源数据':
					api.iflogin(tmpGuid).then((res2) => {
						function showData(val) {
							return val;
						}
						let res = eval(res2);

						if (!res.UserToken) {
							_this.$message.error('请先登录！');
							window.location.href =
								'http://d.drcnet.com.cn/eDRCNet.Common.Web/login/login.aspx?gourl=http://' +
								this.urlHost +
								'/index.html#/Index';
						} else {
							_this.ifRightsFn().then((ress) => {
								if (!ress) {
									this.$message.error(
										'您暂无权限，请先购买！'
									);
									return;
								} else {
									if (num == 0 || num == 1) {
										_this.$router.push({
											path:
												'/encolumn?id=76&name=能源数据&uid=1-0',
										});
										window.location.reload();
									}
								}
							});
						}
					});
					break;
				case '交易数据':
					api.iflogin(tmpGuid).then((res2) => {
						function showData(val) {
							return val;
						}
						let res = eval(res2);

						if (!res.UserToken) {
							_this.$message.error('请先登录！');
							window.location.href =
								'http://d.drcnet.com.cn/eDRCNet.Common.Web/login/login.aspx?gourl=http://' +
								this.urlHost +
								'/index.html#/Index';
						} else {
							_this.ifRightsFn().then((ress) => {
								if (!ress) {
									this.$message.error(
										'您暂无权限，请先购买！'
									);
									return;
								} else {
									if (num == 0 || num == 1) {
										_this.$router.push({
											path:
												'/trancolumn?id=77&name=交易数据',
										});
										window.location.reload();
									}
								}
							});
						}
					});
					break;
				case '排放数据':
					api.iflogin(tmpGuid).then((res2) => {
						function showData(val) {
							return val;
						}
						let res = eval(res2);

						if (!res.UserToken) {
							_this.$message.error('请先登录！');
							window.location.href =
								'http://d.drcnet.com.cn/eDRCNet.Common.Web/login/login.aspx?gourl=http://' +
								this.urlHost +
								'/index.html#/Index';
						} else {
							_this.ifRightsFn().then((ress) => {
								if (!ress) {
									this.$message.error(
										'您暂无权限，请先购买！'
									);
									return;
								} else {
									if (num == 0 || num == 1) {
										_this.$router.push({
											path:
												'/discolumn?id=79&name=排放数据',
										});
										window.location.reload();
									}
								}
							});
						}
					});
					break;
				case '产品数据':
					api.iflogin(tmpGuid).then((res2) => {
						function showData(val) {
							return val;
						}
						let res = eval(res2);

						if (!res.UserToken) {
							_this.$message.error('请先登录！');
							window.location.href =
								'http://d.drcnet.com.cn/eDRCNet.Common.Web/login/login.aspx?gourl=http://' +
								this.urlHost +
								'/index.html#/Index';
						} else {
							_this.ifRightsFn().then((ress) => {
								if (!ress) {
									this.$message.error(
										'您暂无权限，请先购买！'
									);
									return;
								} else {
									if (num == 0 || num == 1) {
										_this.$router.push({
											path:
												'/lvcolumn?id=91&name=产品数据',
										});
										window.location.reload();
									}
								}
							});
						}
					});
				default:
					if (item.url) {
						this.$router
							.replace({
								path: item.url,
							})
							.catch((err) => {
								if (err.name !== 'NavigationDuplicated') {
									console.error(err);
								}
							});
						window.location.reload();
					}
					break;
			}
		},
		//点击链接跳转页面-不验证权限
		pageToUrlTwoNoLogin(_name, num = 0, item) {
			let _this = this;
			let tmpGuid = this.guid;
			// //console.log(_name,'name');
			switch (_name) {
				case '能源数据':
					_this.$router.push({
						path: '/encolumn?id=76&name=能源数据&uid=1-0',
					});
					window.location.reload();
					break;
				case '交易数据':
					_this.$router.push({
						path: '/trancolumn?id=77&name=交易数据',
					});
					window.location.reload();
					break;
				case '排放数据':
					_this.$router.push({
						path: '/discolumn?id=79&name=排放数据',
					});
					window.location.reload();
					break;
				case '产品数据':
					_this.$router.push({
						path: '/lvcolumn?id=91&name=产品数据',
					});
					window.location.reload();
				default:
					if (item.url) {
						this.$router
							.replace({
								path: item.url,
							})
							.catch((err) => {
								if (err.name !== 'NavigationDuplicated') {
									console.error(err);
								}
							});
						window.location.reload();
					}
					break;
			}
		},
	},
	created() {
		window.that = this;
		this.figgerPrint();
	},
	mounted() {
		setTimeout(() => {
			$('.el-input-group__append, .el-input-group__prepend').css({
				'background-color': '#fff',
				'border-radius': '0',
				border: 'none',
				'border-right': '1px solid #EBEBEB',
				color: '#333',
			});
			$('.el-input__inner').css({ border: 'none' });
			$('.el-input-group__append').css({
				border: 'none',
				'background-color': '#4eac41',
			});
		}, 200);
		// 监听滚动事件
		window.onscroll = this.handleScroll;

		this.fetchData();
	},
	// 不影响其他组件要离开的时候解绑
	beforeDestroy() {
		window.onscroll = null;
	},
};
</script>
<style scoped lang="less">
.header {
	width: 100%;
	height: 360px;
	background: url('../assets/header/bannernew.png') no-repeat center;
	background-size: cover;
	position: relative;
	margin-bottom: 38px;
	z-index: 101;
}
.header_main_box {
	width: 1300px;
	overflow: hidden;
	margin: 0 auto;
}
.header_top_box {
	width: 100%;
	height: 273px;
	line-height: 14px;
	overflow: hidden;
	margin-top: 20px;
}
.header_top_box li {
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #333333;
	padding: 0 13px;
	float: right;
	border-left: 1px solid rgba(96, 96, 96, 0.4);
	cursor: pointer;
}
.header_top_box li a {
	color: #333333;
}
.header_top_box li:last-child {
	border-left: none;
}
.header_top_title {
	display: block;
	width: 800px;
	margin-top: 87px;
}
.header_top_input_box {
	position: absolute;
	bottom: 93px;
	right: 301px;
	width: 480px;
	height: 40px;
	// float: right;
	// margin-top: 20px;
	// margin-bottom: 24px;
}

.input-with-select {
	float: left;
	width: 328px;
	border-radius: 0 !important;
	border: none !important;
	background: #fff;
}
.input-with-select .el-input-group__prepend {
	background-color: #fff !important;
	border-radius: 0 !important;
}
.header-select {
	width: 84px;
	font-size: 12px;
	border-radius: 0 !important;
}
.header-search-btn {
	width: 66px;
	background: #4eac41 !important;
	color: #fff !important;
	border-radius: 0 !important;
	font-size: 14px;
	font-family: Source Han Sans CN;
}
.header-search-btn2 {
	width: 76px;
	height: 40px;
	display: inline-block;
	float: left;
	text-align: center;
	line-height: 40px;
	background: #1e4b17 !important;
	color: #fff !important;
	border-radius: 0 !important;
	font-size: 14px;
	font-family: Source Han Sans CN;
}
.header-search-btn3 {
	width: 76px;
	height: 40px;
	display: inline-block;
	float: right;
	text-align: center;
	line-height: 40px;
	background: #e6a23c !important;
	color: #fff !important;
	border-radius: 0 !important;
	font-size: 14px;
	font-family: Source Han Sans CN;
}
.header_main2_box {
	// position: absolute;
	// bottom: 0;
	width: 100%;
	height: 105px;
	box-sizing: border-box;
	background: rgba(17, 106, 0, 0.9);
	// border: 1px solid rgba(17, 106, 0, 1);
}
.header_main2_center_box {
	width: 1300px;
	height: 55px;
	margin: 0 auto 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.header_index_url {
	// writing-mode: vertical-rl;
	// -webkit-writing-mode: vertical-lr;
	// -ms-writing-mode: vertical-lr;
	font-size: 16px;
	font-family: Microsoft YaHei;
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	position: relative;
	// line-height: 20px;
	// letter-spacing: 8px;
	// margin-top: 4px;
}
.header_main2_center_box span {
	width: 1px;
	height: 38px;
	border-right: 1px dashed #ffffff;
	opacity: 0.3;
	display: inline-block;
	vertical-align: top;
	margin-top: 6px;
	float: left;
}
.header_title_box {
	display: inline-block;
	height: 50px;
	vertical-align: top;
}
.header_title_one {
	width: 32px;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #ffffff;
	display: inline-block;
	margin-left: 16px;
	float: left;
}
.header_title_two_box {
	// overflow: hidden;
	display: inline-block;
	height: 48px;
	width: 276px;
	float: left;
}
.header_title_two_box:first-child {
	width: 276px !important;
}

.header_title_two {
	display: inline-block;
	margin-left: 19px;
	font-size: 16px;
	line-height: 16px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #ffffff;
	margin-bottom: 4px;
	margin-top: 4px;
	position: relative;
}
.header_top_alert_box {
	position: absolute;
	top: 25px;
	left: -25px;
	min-width: 120px;
	display: none;
	z-index: 101;
}
/deep/.el-card__body {
	padding: 10px 0;
}
.header_top_alert_box.active {
	display: block;
}
.header_top_alert_box a {
	display: block;
	text-align: center;
	margin-bottom: 14px;
	background: #fff;
	color: #666666;
	padding: 10px;
	margin: 0;
}
.header_top_alert_box a:hover {
	color: #439238;
}
.fixed {
	position: fixed;
	top: 0px;
	left: 0px;
	width: 99%;
	height: 74px;
	// opacity: 0.7;
	background: rgba(17, 106, 0, 1);
	z-index: 100;
}
.hotKeyImg {
	width: 100%;
	height: 50px;
	background: linear-gradient(0deg, #c5ecba, #ffffff);
	.hotKey {
		width: 1300px;
		margin: 0 auto;
		line-height: 50px;
		.hotTitle {
			font-family: Microsoft YaHei;
			font-weight: bold;
			font-size: 15px;
			color: #106906;
		}
		.hotName {
			border-right: 1px solid rgba(162, 181, 160, 1);
			padding: 0 14px;
			a {
				font-family: Microsoft YaHei;
				font-weight: 400;
				font-size: 14px;
				color: #084f00;
			}
		}
	}
	.hotKey .hotName:last-child {
		border-right: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue